import { Typography } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import theme from 'theme'

export const ConcurrentIcon: React.FC = ({ ...rest }) => {
  return (
    <Icon
      css={{
        transform: 'scaleY(-1)',
        padding: 8,
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: '100%'
      }}
      icon="split"
      {...rest}
    />
  )
}

export function StatusChecksIcon({ ...rest }) {
  return (
    <Icon
      css={{
        width: 20,
        height: 20,
        padding: 8,
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: '100%'
      }}
      icon="wavePulse"
      {...rest}
    />
  )
}

export function ExternalStepsIcon({ ...rest }) {
  return (
    <Icon
      css={{
        width: 20,
        height: 20,
        padding: 8,
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: '100%'
      }}
      icon="gearCode"
      {...rest}
    />
  )
}

export function RollbackExternalStepsIcon({ ...rest }) {
  return (
    <Icon
      css={{
        width: 20,
        height: 20,
        padding: 8,
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: '100%'
      }}
      icon="arrowRotateLeft"
      {...rest}
    />
  )
}

export function NodeListIcon({ ...rest }) {
  return (
    <Icon
      css={{
        width: 20,
        height: 20,
        padding: 8,
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: '100%'
      }}
      icon="clipboardList"
      {...rest}
    />
  )
}

export function ActiveNodeIcon({ ...rest }) {
  return (
    <Icon
      css={{
        width: 20,
        height: 20,
        padding: 8,
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: '100%'
      }}
      icon="solidArrowsRotate"
      spinning={true}
      {...rest}
    />
  )
}

export function LinearNodeIcon({ ...rest }) {
  return (
    <Icon
      css={{
        width: 20,
        height: 20,
        padding: 8,
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: '100%'
      }}
      icon="arrowDown"
      {...rest}
    />
  )
}

export function NodeIcon({ ...rest }) {
  return (
    <Icon
      css={{
        padding: 8,
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: '100%'
      }}
      icon="arrowRight"
      {...rest}
    />
  )
}

export function NodeNumber({ children, ...rest }) {
  return (
    <Typography
      css={{
        border: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: '100%',
        padding: 3,
        minWidth: 30,
        textAlign: 'center'
      }}
      {...rest}
    >
      {children}
    </Typography>
  )
}
